<template>
  <div>
    <v-card flat>
      <div class="mt-10 d-flex justify-space-between heading-2">
        <div>Purchases and Billing</div>
        <!-- <template v-slot:activator="{ on, attrs }"> -->
        <div class="d-flex justify-end px-10">
          <div>
            <div class="d-flex justify-end">
              <v-btn
                rounded
                outlined
                color="#1884CD"
                class="mb-2"
                dark
                style="text-transform: none !important; border: 1px solid #d2e5fc"
                @click="Memberinfoeditdialog = true"
                >Add Payment</v-btn
              >
            </div>
            <div class="style_txt_hh1">To add Exam payments, go to the "Exams & Credentials" tab.</div>
          </div>
          <!-- v-bind="attrs"
              v-on="on" -->
        </div>

        <!-- </template> -->
        <v-dialog v-model="Memberinfoeditdialog" width="650" persistent>
          <v-card class="px-10 pt-8 pb-4" v-if="Memberinfoeditdialog">
            <div>
              <BillingPurchasePaymentComponent
                :BillingandPurchasePaymentProcess="Memberinfoeditdialog"
                @close="close"
              />
            </div>
          </v-card>
        </v-dialog>
      </div>

      <div class="mt-9">
        <v-tabs v-model="tab" slider-color="transparent">
          <!-- background: rgba(236, 241, 242, 1) -->
          <div class="d-flex" style="width: 100%">
            <v-tab
              ripple
              href="#tab-1"
              @click="
                () => {
                  this.tab == 'tab-1';
                }
              "
            >
              <span class="tabs_style text_style"> Store List </span></v-tab
            >
            <v-tab
              ripple
              href="#tab-2"
              @click="
                () => {
                  this.tab == 'tab-2';
                }
              "
            >
              <span class="tabs_style text_style"> Seminar List </span>
            </v-tab>
            <v-tab
              ripple
              href="#tab-3"
              @click="
                () => {
                  this.tab == 'tab-3';
                }
              "
            >
              <span class="tabs_style text_style"> Exam List </span></v-tab
            >
          </div>
          <v-tab-item value="tab-1">
            <v-card class="mt-5 mb-14" outlined flat>
              <v-data-table
                :headers="storeOrderheaders"
                :items="getUserPurchaseAndBillings.store"
                :loading="tableLoader"
                loading-text="Loading... Please wait"
                disable-pagination
                :hide-default-footer="true"
                class="mytable"
              >
                <template v-slot:[`item.index`]="{ index }">
                  <b class="index_index_text">
                    {{ index + 1 }}
                  </b>
                </template>

                <template v-slot:[`item.OrderCode`]="{ item }">
                  <b class="index_index_text"> {{ item.OrderCode }} </b>
                </template>
                <template v-slot:[`item.OrderDate`]="{ item }">
                  <span class="index_index_text">
                    {{ item.Items[0].OrderDate.split("T")[0] }}
                  </span>
                </template>
                <template v-slot:[`item.User`]="{ item }">
                  <span class="index_index_text">
                    {{
                      item.Items[0]?.IsUser
                        ? item.Items[0]?.User.FirstName +
                          " " +
                          item.Items[0]?.User.LastName
                        : "Guest User"
                    }}
                  </span>
                </template>
                <template v-slot:[`item.Payment`]="{ item }">
                  <span class="index_head_text">
                    {{ item.Items[0]?.PaymentType === 1 ? "Card" : item.Items[0]?.PaymentType === 2 ? "Paypal" : "Admin" }}
                  </span>
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  <span class="index_head_text">
                    {{
                      item.Items[0]?.Product?.CategoryId === 26
                        ? item.Items[0]?.Payment?.Price?.toFixed(2) 
                        : (
                            Number(calculateTableTotalDiscount(item.Items).totalAmountWithDiscount) +
                            shippingPriceStoreTable(item) +
                            calculateTaxStoreTable(item) -
                            calculateTableTotalDiscount(item.Items).couponDiscount
                          )?.toFixed(2)
                    }}
                  </span> 
                </template>
                <template v-slot:[`item.ViewDetails`]="{ item }">
                  <div class="text-center">
                    <v-btn
                      depressed
                      outlined
                      text
                      color="primary"
                      small
                      @click="orderDetails(item.OrderCode)"
                    >
                      View Details
                    </v-btn>
                  </div>
                </template>
                <template v-slot:[`item.InvoiceStatus`]="{ item }">
                  <v-chip
                    class="px-5"
                    text-color="#06A23B"
                    style="background: rgba(227, 243, 233, 1)"
                  >
                    {{
                      item.Items[0]?.InvoiceStatus === 2
                        ? "NEW"
                        : item.Items[0]?.InvoiceStatus === 3
                        ? "RECEIVED"
                        : item.Items[0]?.InvoiceStatus === 4
                        ? "SHIPPED"
                        : item.Items[0]?.InvoiceStatus === 5
                        ? "INVOICED"
                        : "VOID"
                    }}
                  </v-chip>
                </template>
                <template v-slot:[`item.TrackingId`]="{ item }">
                  <div class="pt-8">
                    <v-text-field
                    v-if="item.Items[0]"
                      v-model="item.Items[0].TrackingId"
                      dense
                      readonly
                      outlined
                    ></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon color="#A1A1A6" @click="openInvoiceDialog('store', item)">
                    mdi-file-document
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
            
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card class="mt-5 mb-14" outlined flat>
              <v-data-table
                :headers="seminarOrderheaders"
                :items="getUserPurchaseAndBillings.seminarspurchases"
                :loading="tableLoader"
                loading-text="Loading... Please wait"
                disable-pagination
                :hide-default-footer="true"
                class="mytable"
              >
                <template v-slot:[`item.index`]="{ index }">
                  <b class="index_index_text">
                    {{ index + 1 }}
                  </b>
                </template>

                <template v-slot:[`item.OrderCode`]="{ item }">
                  <b class="index_index_text"> {{ item.OrderCode }} </b>
                </template>
                <template v-slot:[`item.CreatedDate`]="{ item }">
                  <span class="index_index_text">
                    <!-- {{ item.CreatedDate?.split("T")[0] }} -->
                    {{ item?.SeminarDetails[0]?.CreatedDate?.split("T")[0] }}
                  </span>
                </template>
                <template v-slot:[`item.PaidAmount`]="{ item }">
                  <span class="index_head_text">
                    {{ calculateTotalPaidAmount(item) }}
                  </span>
                </template>
                <template v-slot:[`item.Course`]="{ item }">
                  <span class="index_head_text">
                    {{ item?.SeminarDetails[0]?.Course }}
                  </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon color="#A1A1A6" @click="openInvoiceDialog('seminar', item)">
                    mdi-file-document
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
            
          </v-tab-item>
          <v-tab-item value="tab-3">
            <v-card class="mt-5 mb-14" outlined flat>
              <v-data-table
                :headers="examPaymentheaders"
                :items="getUserPurchaseAndBillings.examPayments"
                :loading="tableLoader"
                loading-text="Loading... Please wait"
                disable-pagination
                :hide-default-footer="true"
                class="mytable"
              >
                <template v-slot:[`item.index`]="{ index }">
                  <b class="index_index_text">
                    {{ index + 1 }}
                  </b>
                </template>

                <template v-slot:[`item.OrderCode`]="{ item }">
                  <b class="index_index_text"> {{ item.OrderCode }} </b>
                </template>
                <template v-slot:[`item.CreatedDate`]="{ item }">
                  <span class="index_index_text">
                    {{ item.CreatedDate.split("T")[0] }}
                  </span>
                </template>
                <template v-slot:[`item.PaidAmount`]="{ item }">
                  <span class="index_head_text">
                     {{ item.PaidAmount }}
                  </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon color="#A1A1A6" @click="openInvoiceDialog('exam', item)">
                    mdi-file-document
                  </v-icon>
                </template>
                <template v-slot:[`item.ExamCredentials`]="{ item }">
                  <span>
                    {{ getExamCredentialsLabel(item.ExamCredentials) }}
                  </span>
                </template>
                <template v-slot:[`item.IsOnlinePayment`]="{ item }">
                  <span>
                    {{
                      item.IsOnlinePayment ? "Online" : "Offline"
                    }}
                  </span>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
      <v-dialog v-model="storeinvoicedialog" max-width="750" @click:outside="closeDialog">
        <div v-if="selectedStorePayment && selectedStorePayment.Items">
          <v-card flat class="py-12 px-10">
            <div ref="pdfContent">
              <v-card class="d-flex justify-start px-6" flat>
                <img src="../../../assets/images/iba-logo.svg" width="130" height="90" alt="">
              </v-card>
    
              <div class="px-6">
                <div>
                  <div class="my-2">
                    <div class="heading-3">Invoice</div>
                    <div class="d-flex items-center my-2 light-content" style="justify-content:space-between">
                      <div>
                        <span class="">Order number: {{ selectedStorePayment?.OrderCode }}</span>
                      </div>
                      <div>{{ formatDate(selectedStorePayment?.Items[0].OrderDate) }}</div>
                    </div>
                    <div>
                      <span class="light-content"> Issued to: {{ GetPreviewUser.Email }}</span>
                    </div>
                  </div>
                </div>
                <v-divider style="border:1px solid black"> </v-divider>
                <span class="light-content mt-4"><b>Charges*</b></span>
                <div>
                  <i class="mt-2 light-content">*All prices in US Dollar.</i>
                </div>
                <table class="w-100 my-6">
                  <tr>
                    <th style="width: 40%">
                      <div class="d-flex justify-center py-2 text-center">Name</div>
                    </th>
                    <th style="width: 20%">
                      <div class="d-flex justify-center py-2 text-center">Unit Price</div>
                    </th>
                    <th style="width: 20%">
                      <div class="d-flex justify-center py-2 text-center">Quantity</div>
                    </th>
                    <th style="width: 20%">
                      <div class="d-flex justify-center py-2 text-center">Subtotal</div>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in selectedStorePayment.Items"
                  :key="index">
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                        <!-- {{ item.name }} -->
                        {{ item?.Product?.ProductName }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                        <span v-if="selectedStorePayment?.Items[0]?.Product?.CategoryId === 26">
                          {{ (selectedStorePayment?.Items[0]?.Payment?.Price / item?.Quantity)?.toFixed(2) }}
                        </span>
                        <span v-else>{{ item?.Product?.PublicPrice }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                        {{ item?.Quantity }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                        <span v-if="selectedStorePayment?.Items[0]?.Product?.CategoryId === 26">
                          {{ selectedStorePayment?.Items[0]?.Payment?.Price?.toFixed(2) }}
                        </span>
                        <span v-else>
                          {{ (item?.Product?.PublicPrice * item?.Quantity)?.toFixed(2) }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <div class="d-flex justify-start px-4 py-2">
                        <b>Product Total</b>
                      </div>
                    </td>
    
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                        $ <span v-if="selectedStorePayment?.Items[0]?.Product?.CategoryId === 26">
                          {{ selectedStorePayment?.Items[0]?.Payment?.Price?.toFixed(2) }}
                        </span>
                        <span v-else>{{
                          calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                            .totalAmount
                        }}</span>
                        
                      </div>
                    </td>
                  </tr>
                </table>
                <div class="light-content">
                  <v-row class="mb-8">
                    <v-col cols="12" sm="4" md="5"></v-col>
                    <v-col cols="12" sm="8" md="7">
                      <div class="d-flex justify-space-between">
                        <span>Product Discount: </span>	
                        <span>
                          USD {{
                            calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                            .totalDiscountApplied
                          }}
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>Coupon Discount: </span>	
                        <span>
                          USD {{
                            calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                            .couponDiscount
                          }}
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>Total Discount: </span>	
                        <span>
                          USD {{ totalDiscountvalue }}
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>Subtotal: </span>	
                        <span>
                          USD <span v-if="selectedStorePayment?.Items[0]?.Product?.CategoryId === 26">
                            {{ selectedStorePayment?.Items[0]?.Payment?.Price?.toFixed(2) }}
                          </span><span v-else>{{
                            (calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                            .totalAmountWithDiscount - calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                            .couponDiscount)?.toFixed(2)
                          }}</span>
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>Shipping: </span>	
                        <span>
                          USD {{ (shippingPrice)?.toFixed(2) }}
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>Tax: </span>	
                        <span>
                          USD {{ calculateTax?.toFixed(2) }}
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>Total:</span>	
                        <span>
                          USD <span v-if="selectedStorePayment?.Items[0]?.Product?.CategoryId === 26">
                            {{ selectedStorePayment?.Items[0]?.Payment?.Price?.toFixed(2) }}
                          </span><span v-else>{{
                            (Number(calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                              .totalAmountWithDiscount) + shippingPrice + calculateTax - calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                              .couponDiscount)?.toFixed(2)
                          }}</span>

                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <b><span>Paid:</span></b>	
                        <b><span>
                          USD <span v-if="selectedStorePayment?.Items[0]?.Product?.CategoryId === 26">
                            {{ selectedStorePayment?.Items[0]?.Payment?.Price?.toFixed(2) }}
                          </span><span v-else>{{
                            (Number(calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                              .totalAmountWithDiscount) + shippingPrice + calculateTax - calculateTotalDiscount(selectedStorePayment && selectedStorePayment?.Items)
                              .couponDiscount)?.toFixed(2)
                          }}</span>
                        </span></b>
                      </div>
                    </v-col>
                  </v-row>
                  <div>
                    <div class="mb-4"><b>Payment Method:</b> <span v-if="selectedStorePayment?.Items[0]?.PaymentType == 1">{{maskCardNumber(selectedStorePayment?.Items[0]?.Payment?.CardNumber)}}</span><span v-else-if="selectedStorePayment?.Items[0]?.PaymentType == 2">Paypal</span><span v-else>ADMIN</span></div>
                    <div>
                      <b>Shipping Address:</b>
                      <div>
                        <div>
                          {{ selectedStorePayment && selectedStorePayment?.Items[0]?.Shipping?.StreetAddress1 }}
                          {{ selectedStorePayment && selectedStorePayment?.Items[0]?.Shipping?.StreetAddress2 }}
                        </div>
                        <div>
                          {{ selectedStorePayment && selectedStorePayment?.Items[0]?.Shipping?.City }}
                          {{ selectedStorePayment && selectedStorePayment?.Items[0]?.Shipping?.Province }}
                          {{ selectedStorePayment && selectedStorePayment?.Items[0]?.Shipping?.ZipCode }}
                        </div>
                        <div>
                          {{ selectedStorePayment && selectedStorePayment?.Items[0]?.Shipping?.Country }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </v-dialog>
      <v-dialog v-model="seminarinvoicedialog" max-width="750" @click:outside="closeDialog">
        <div>
          <v-card flat class="py-12 px-10">
            <div ref="pdfContent">
              <v-card class="d-flex justify-start px-6" flat>
                <img src="../../../assets/images/iba-logo.svg" width="130" height="90" alt="">
              </v-card>
    
              <div class="px-6">
                <div>
                  <div class="my-2">
                    <div class="heading-3">Invoice</div>
                    <div class="d-flex items-center my-2 light-content" style="justify-content:space-between">
                      <div>
                        <span class="">Order number: {{ selectedSeminarPayment?.OrderCode }}</span>
                      </div>
                      <div>{{ formatDate(selectedSeminarPayment?.SeminarDetails[0]?.CreatedDate) }}</div>
                    </div>
                    <div>
                      <span class="light-content"> Issued to: {{ GetPreviewUser.Email }}</span>
                    </div>
                  </div>
                </div>
                <v-divider style="border:1px solid black"> </v-divider>
                <span class="light-content mt-4"><b>Charges*</b></span>
                <div>
                  <i class="mt-2 light-content">*All prices in US Dollar.</i>
                </div>
                <table class="w-100 my-6">
                  <tr>
                    <th style="width: 30%">
                      <div class="d-flex justify-center py-2 text-center">Name</div>
                    </th>
                    <th style="width: 15%">
                      <div class="d-flex justify-center py-2 text-center">Full Price</div>
                    </th>
                    <th style="width: 15%">
                      <div class="d-flex justify-center py-2 text-center">Early Bird Price</div>
                    </th>
                    <th style="width: 25%">
                      <div class="d-flex justify-center py-2 text-center">
                        Monitor Rate Discount
                      </div>
                    </th>
                    <th style="width: 15%">
                      <div class="d-flex justify-center py-2 text-center">Subtotal</div>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in selectedSeminarPayment?.SeminarDetails"
                  :key="index">
                    <td>
                      <div class="d-flex flex-column justify-center py-2 text-center">
                        <span>{{ item?.Course }}</span>
                        <div v-if="item?.SeminarDateAndTime?.length > 1" >
                          ({{
                            extractMonthAndDate(item?.SeminarDateAndTime[0]?.Date)
                          }} to {{ extractMonthAndDate(item?.SeminarDateAndTime[1]?.Date) }})
                        </div>
                        <div v-else >({{
                            extractMonthAndDate(item?.SeminarDateAndTime[0]?.Date)
                          }})</div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                          {{item?.FullPrice?.toFixed(2) }} USD
                      </div>
                    </td>
                    <td>
                      <div
                        class="d-flex justify-center py-2 text-center" v-if="item?.EarlyBirdPrice"
                        >
                        <!-- v-if="isDateEqualOrGreater(item.EarlyBirdEndTime)" -->
                          {{ item?.EarlyBirdPrice?.toFixed(2) }} USD
                      </div>
                    </td>
                    <td>
                      <div
                        class="d-flex justify-center py-2 text-center"
                      >
                        <span v-if="item.MonitorRate && item.MonitorDiscount !== 0">{{ item.MonitorDiscount }}%</span>
                      </div>
                    </td>
                    <td>
                      <div
                        class="d-flex justify-center py-2 text-center"
                        
                      >
                        {{ totalSeminarPrice(item) }}.00 USD
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-start px-4 py-2 ">
                        <b>Seminars Total</b>
                      </div>
                    </td>
    
                    <td>
                      <div class="d-flex justify-center py-2 text-center">
                        <b> {{seminarsSubtotal}}.00 USD</b>
                      </div>
                    </td>
                  </tr>
                </table>
                <div class="light-content">
                  <v-row class="mb-8">
                    <v-col cols="12" md="6"></v-col>
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-space-between"><span>Discount: </span>	<span>USD {{ seminarDiscountValue }}</span></div>
                      <div class="d-flex justify-space-between"><span>Subtotal: </span>	<span>USD {{(seminarsSubtotalWithDiscount)?.toFixed(2)}}</span></div>
                      <div class="d-flex justify-space-between"><span>Shipping: </span>	<span>USD 0.00</span></div>
                      <div class="d-flex justify-space-between"><span>Tax: </span>	<span>USD 0.00</span></div>
                      <div class="d-flex justify-space-between"><span>Total:</span>	<span>USD {{(seminarsSubtotalWithDiscount)?.toFixed(2)}}</span></div>
                      <div class="d-flex justify-space-between"><b><span>Paid:</span></b>	<b><span>USD {{(seminarsSubtotalWithDiscount)?.toFixed(2)}}</span></b></div>
                    </v-col>
                  </v-row>
                  <div>
                    <b>Payment Method:</b> <span v-if="selectedSeminarPayment?.SeminarDetails[0]?.PaymentType == 1">{{maskCardNumber(selectedSeminarPayment?.SeminarDetails[0]?.Payment?.CardNumber)}}</span><span v-else-if="selectedSeminarPayment?.SeminarDetails[0]?.PaymentType == 2">Paypal</span><span v-else>ADMIN</span>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </v-dialog>
      <v-dialog v-model="examinvoicedialog" max-width="680" @click:outside="closeDialog">
          <div>
            <v-card flat class="py-12 px-10">
              <div ref="pdfContent">
                <v-card class="d-flex justify-start px-6" flat>
                  <img src="../../../assets/images/iba-logo.svg" width="130" height="90" alt="">
                </v-card>
      
                <div class="px-6">
                  <div>
                    <div class="my-2">
                      <div class="heading-3">Invoice</div>
                      <div class="d-flex items-center my-2 light-content" style="justify-content:space-between">
                        <div>
                          <span class="">Order number: {{ selectedExamPayment?.OrderCode }}</span>
                        </div>
                        <div>{{ formatDate(selectedExamPayment?.CreatedDate) }}</div>
                      </div>
                      <div>
                        <span class="light-content"> Issued to: {{ getUserPurchaseAndBillings.UserEmail }}</span>
                      </div>
                    </div>
                  </div>
                  <v-divider style="border:1px solid black"> </v-divider>
                  <span class="heading-2 mt-4">Charges*</span>
                  <div>
                    <i class="mt-2 light-content">*All prices in US Dollar.</i>
                  </div>
                  <div class="light-content">
                    <div class="my-8">
                      <div class="d-flex justify-space-between">
                        <span>Exam Processing Payment: <b>{{getExamCredentialsLabel(selectedExamPayment?.ExamCredentials)}}</b></span>
                        <span v-if="selectedExamPayment?.ExamCredentials === 1">USD 50.00</span>
                        <span v-else-if="selectedExamPayment?.ExamCredentials === 2">USD 50.00</span>
                        <span v-else-if="selectedExamPayment?.ExamCredentials === 3 || selectedExamPayment?.ExamCredentials === 4">USD 100.00</span>
                        <span v-else-if="selectedExamPayment?.ExamCredentials === 5">USD 100.00</span>
                      </div>
                      <div>
                        Membership renewal date: {{ getUserPurchaseAndBillings?.MemberShipRenewalDate?.split("T")[0].replaceAll('-','/') }}
                      </div>
                    </div>
                    <v-row class="mb-8">
                      <v-col cols="12" md="5"></v-col>
                      <v-col cols="12" md="7">
                        <div class="d-flex justify-space-between"><span>Total:</span>	<span>USD {{selectedExamPayment?.PaidAmount?.toFixed(2)}}</span></div>
                        <div class="d-flex justify-space-between"><b><span>Paid:</span></b>	<b><span>USD {{selectedExamPayment?.PaidAmount?.toFixed(2)}}</span></b></div>
                      </v-col>
                    </v-row>
                    <div>
                      <b>Payment Method:</b> <span v-if="selectedExamPayment?.IsOnlinePayment">{{maskCardNumber(selectedExamPayment?.Payment?.CardNumber)}}</span><span v-else>ADMIN</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
      </v-dialog>
      
     

      <!-- <v-card class="mt-5 mb-14" outlined flat>
        <v-data-table
          :headers="orderheaders"
          :items="GetUserOrders"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          disable-pagination
          :hide-default-footer="true"
          class="mytable"
        >
          <template v-slot:[`item.index`]="{ index }">
            <b class="index_index_text">
              {{ index + 1 }}
            </b>
          </template>

          <template v-slot:[`item.order`]="{ item }">
            <b class="index_index_text"> {{ item.OrderCode }} </b>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <span class="index_index_text">
              {{ item.Items[0].OrderDate.split("T")[0] }}
            </span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span class="index_head_text">
              $ {{ item.Items[0].Payment.Price }}
            </span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span>
              {{
                item.Items[0].Status === 2
                  ? "NEW"
                  : item.Items[0].Status === 3
                  ? "RECEIVED"
                  : item.Items[0].Status === 4
                  ? "SHIPPED"
                  : item.Items[0].Status === 5
                  ? "INVOICED"
                  : "VOID"
              }}
            </span>
          </template>
          <template v-slot:[`item.invoice`]>
            <v-icon color="#A1A1A6"> mdi-file-document </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="text-center">
              <v-btn
                depressed
                outlined
                text
                color="primary"
                small
                @click="orderDetails(item.OrderCode)"
              >
                View Details
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card> -->
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BillingPurchasePaymentComponent from "../paymentcomponents/BillingPurchasePaymentComponent.vue";

export default {
  components: {
    BillingPurchasePaymentComponent,
  },
  computed: {
    ...mapGetters(["GetPreviewUser", "GetUserOrders","getUserPurchaseAndBillings"]),
    getExamCredentialsLabel() {
    return (examCredentialsLabel) => {
      switch (examCredentialsLabel) {
        case 1:
          return "CBP";
        case 2:
          return "CBP-A";
        case 3:
          return "AdvCBP 4(7) & 9";
        case 4:
          return "AdvCBP 3 & 6";
        case 5:
          return "PaRama";
        case 6:
          return "Adv_CBP";
          // return "Adv_CBP479";
        case 7:
          return "Adv_CBP";
          // return "Adv_CBP36";
        default:
          return "";
      }
    };
  },
    getCredentialLabel() {
      return (credentialLevel) => {
        switch (credentialLevel) {
          case 1:
            return "CBP";
          case 2:
            return "CBP-A";
          case 3:
            return "AdvCBP";
          case 4:
            return "PaRama";
          default:
            return "";
        }
      };
    },
    
    seminarsSubtotal() {
      return this.selectedSeminarPayment?.SeminarDetails?.reduce((total, item) => {
        return total + this.totalSeminarPrice(item);
      }, 0);
    },
    seminarDiscountValue() {
      // Calculate the discount for seminars based on DiscountType
      if (
        this.selectedSeminarPayment &&
        this.selectedSeminarPayment?.SeminarDetails[0]?.Coupon
      ) {
        const discount = this.selectedSeminarPayment.SeminarDetails[0].Coupon.DiscountValue;
        const discountType = this.selectedSeminarPayment.SeminarDetails[0].Coupon.DiscountType;
        // Convert percentage discount to dollar value if DiscountType is 1
        return discountType === 1
          ? ((discount / 100) * this.seminarsSubtotal)?.toFixed(2)
          : discount?.toFixed(2);
      }
      return "0.00";
    },
    seminarsSubtotalWithDiscount() {
      return this.seminarsSubtotal - this.seminarDiscountValue;
    },
    shippingPrice() {
      let str = this.selectedStorePayment?.Items[0]?.Shipping?.ShippingMethod;
      let match = str?.match(/\(([^)]+)\)/);
      if (match) {
        let number = parseFloat(match[1]);
        return number;
      }
      return 0;
    },
    totalDiscountvalue() {
      const discountApplied = parseFloat(this.calculateTotalDiscount(this.selectedStorePayment && this.selectedStorePayment?.Items).totalDiscountApplied) || 0;
      const couponDiscount = parseFloat(this.calculateTotalDiscount(this.selectedStorePayment && this.selectedStorePayment?.Items).couponDiscount) || 0;

      const totaldiscountvalue = discountApplied + couponDiscount;
      return totaldiscountvalue?.toFixed(2); // If you want to return it as a string with 2 decimal places
    },
    calculateTax() {
      if (
        this.selectedStorePayment &&
        this.selectedStorePayment?.Items[0]?.Shipping?.Country?.toLowerCase() === "united states" &&
        this.selectedStorePayment?.Items[0]?.Shipping?.Province?.toLowerCase() === "fl"
      ) {
        const totalAmountWithDiscount = this.calculateTotalDiscount(this.selectedStorePayment?.Items).totalAmountWithDiscount;

        const hasPhysicalProduct = this.selectedStorePayment?.Items?.some((item) => item?.Product?.IsPhysical);

        if (hasPhysicalProduct) {
          return totalAmountWithDiscount * 0.07;
        }
      }
      return 0;
    },
  },

  name: "seeprofilecomponent",
  data() {
    return {
      dialogWidth: '900',
      data: null,
      examinvoicedialog: false,
      storeinvoicedialog: false,
      seminarinvoicedialog: false,
      selectedExamPayment: null, 
      selectedSeminarPayment: null, 
      selectedStorePayment: null, 
      tab: "tab-1",
      tableLoader: false,
      Memberinfoeditdialog: false,
      btnloader: false,
      btnloader1: false,
      add_dialog: false,
      dialog: false,

      storeOrderheaders: [
        { text: "#", value: "index" },
        { text: "OrderCode", value: "OrderCode" },
        { text: "Date", value: "OrderDate" },
        // { text: "Client", value: "User" },
        { text: "Payment Type", value: "Payment" },
        { text: "Amount", value: "Amount" },
        { text: "Status", value: "InvoiceStatus" },
        { text: "", value: "ViewDetails" },
        // { text: "Tracking #", value: "TrackingId" },
        { text: "Invoice", value: "actions", sortable: false },
      ],
      seminarOrderheaders: [
        { text: "#", value: "index" },
        { text: "OrderCode", value: "OrderCode" },
        { text: "Date", value: "CreatedDate" },
        { text: "Course", value: "Course" },
        { text: "Amount", value: "PaidAmount" },
        { text: "Invoice", value: "actions", sortable: false },
      ],
      examPaymentheaders: [
        { text: "#", value: "index" },
        { text: "OrderCode", value: "OrderCode" },
        { text: "Date", value: "CreatedDate" },
        { text: "Exam Type", value: "ExamCredentials" },
        { text: "Payment", value: "IsOnlinePayment" },
        { text: "Amount", value: "PaidAmount" },
        { text: "Invoice", value: "actions", sortable: false },
      ],

      DataTableTwo: [
        {
          order: 98771,
          date: "11/12/2021",
          amount: "$2,499.75",
          status: "VOID",
          dateshiped: "",
        },
        {
          order: 98770,
          date: "03/02/2021",
          amount: "$9,999.00",
          status: "VOID",
          dateshiped: "",
        },
        {
          order: 97832,
          date: "11/17/2020",
          amount: "$120.00",
          status: "INVOICED",
          dateshiped: "",
        },
        {
          order: 98771,
          date: "11/12/2021",
          amount: "$2,499.75",
          status: "INVOICED",
          dateshiped: "",
        },
        {
          order: 98771,
          date: "11/12/2021",
          amount: "$2,499.75",
          status: "INVOICED",
          dateshiped: "11/12/2021",
        },
        {
          order: 97832,
          date: "11/17/2020",
          amount: "$120.00",
          status: "INVOICED",
          dateshiped: "11/12/2021",
        },
      ],
      tabs: null,
    };
  },
  mounted() {
    if (this.GetPreviewUser == null) {
      this.$router.push("/users");
    }
    this.fetchUserPurchaseAndBillingsData()
    this.$store.dispatch("GetAllSeminarByGroup", { search: "", filter: "" });
  },
  methods: {
    extractMonthAndDate(dateTimeString) {
      const date = new Date(dateTimeString);
      const month = date.toLocaleString("en-US", { month: "short" });
      const day = date.getDate();
      return `${day} ${month}`;
    },
    calculateTaxStoreTable(item) {
      if (
        item &&
        item?.Items[0]?.Shipping?.Country?.toLowerCase() === "united states" &&
        item.Items[0]?.Shipping?.Province?.toLowerCase() === "fl"
      ) {
        const totalAmountWithDiscount = this.calculateTotalDiscount(item?.Items).totalAmountWithDiscount;

        const hasPhysicalProduct = item?.Items?.some((nestedItem) => nestedItem?.Product?.IsPhysical);

        if (hasPhysicalProduct) {
          return totalAmountWithDiscount * 0.07;
        }
      }
      return 0;
    },
    shippingPriceStoreTable(item) {
      let str = item?.Items[0]?.Shipping?.ShippingMethod;
      let match = str?.match(/\(([^)]+)\)/);
      if (match) {
        let number = parseFloat(match[1]);
        return number;
      }
      return 0;
    },
    calculateTableTotalDiscount(items) {
      if (Array.isArray(items) && items?.length > 0) {
        // Calculate the total discounted amount and total amount for all items
        const { totalDiscount, totalAmount } = items.reduce(
          (acc, item) => {
            // Inside the reduce function, calculate the total and discounted amount for each item
            const { discountedAmount, amount } =
              this.calculateAmountAndDiscount(item);

            // Add the discounted amount to the total discount
            acc.totalDiscount += parseFloat(discountedAmount);
            // Add the total amount to the total amount
            acc.totalAmount += parseFloat(amount);

            return acc;
          },
          { totalDiscount: 0, totalAmount: 0 }
        );

        // Calculate the total discount applied to the total amount
        const totalDiscountApplied = totalAmount - totalDiscount;
        const couponDiscount = items[0]?.Coupon?.[0]?.DiscountValue
          ? totalAmount * (parseFloat(items[0].Coupon[0].DiscountValue) / 100)
          : 0;
        // Return an object containing the required values
        return {
          totalAmount: totalAmount?.toFixed(2),
          couponDiscount: couponDiscount?.toFixed(2),
          totalDiscountApplied: totalDiscountApplied?.toFixed(2),
          totalAmountWithDiscount: totalDiscount?.toFixed(2),
        };
      } else {
        // Return an object with default values if the array is empty or invalid
        return {
          totalAmount: 0.00,
          totalDiscountApplied: 0.00,
          totalAmountWithDiscount: 0.00,
          couponDiscount: 0.00,
        };
      }
    },
    totalSeminarPrice(item) {
      const discount = (item.FullPrice * item.MonitorDiscount) / 100; 
      return (item.MonitorRate && item.MonitorDiscount !== 0) ? (item.FullPrice - discount) : this.isDateEqualOrGreater(item.EarlyBirdEndTime)
        ? item.EarlyBirdPrice
        : item.FullPrice;
    },
    isDateEqualOrGreater(inputDateStr) {
      const inputDate = new Date(inputDateStr);
      const currentDate = new Date();

      // Check if the input date is today or a future date
      if (inputDate.getFullYear() > currentDate.getFullYear()) {
        return true;
      } else if (inputDate.getFullYear() === currentDate.getFullYear()) {
        if (inputDate.getMonth() > currentDate.getMonth()) {
          return true;
        } else if (inputDate.getMonth() === currentDate.getMonth()) {
          if (inputDate.getDate() >= currentDate.getDate()) {
            return true;
          }
        }
      }
      return false;
    },
    calculateTotalDiscount(items) {
      if (Array.isArray(items) && items?.length > 0) {
        // Calculate the total discounted amount and total amount for all items
        const { totalDiscount, totalAmount } = items.reduce(
          (acc, item) => {
            // Inside the reduce function, calculate the total and discounted amount for each item
            const { discountedAmount, amount } =
              this.calculateAmountAndDiscount(item);

            // Add the discounted amount to the total discount
            acc.totalDiscount += parseFloat(discountedAmount);
            // Add the total amount to the total amount
            acc.totalAmount += parseFloat(amount);

            return acc;
          },
          { totalDiscount: 0, totalAmount: 0 }
        );

        // Calculate the total discount applied to the total amount
        const totalDiscountApplied = totalAmount - totalDiscount;
        const couponDiscount = this.selectedStorePayment?.Items[0]?.Coupon?.[0]?.DiscountValue
          ? totalAmount * (parseFloat(this.selectedStorePayment.Items[0].Coupon[0].DiscountValue) / 100)
          : 0;
        // Return an object containing the required values
        return {
          totalAmount: totalAmount?.toFixed(2),
          couponDiscount: couponDiscount?.toFixed(2),
          totalDiscountApplied: totalDiscountApplied?.toFixed(2),
          totalAmountWithDiscount: totalDiscount?.toFixed(2),
        };
      } else {
        // Return an object with default values if the array is empty or invalid
        return {
          totalAmount: 0.00,
          totalDiscountApplied: 0.00,
          totalAmountWithDiscount: 0.00,
          couponDiscount: 0.00,
        };
      }
    },
    calculateAmountAndDiscount(item) {
      // Calculate the discounted amount for a single item
      const discountedAmount = (
        (1 - item.Product.DiscountPercentage / 100) * // Discount factor
        item.Product.PublicPrice *
        item.Quantity
      )?.toFixed(2);

      // Calculate the total amount for a single item
      const amount = (item.Product.PublicPrice * item.Quantity)?.toFixed(2);

      // Return an object containing both the total amount and discounted amount
      return { amount, discountedAmount };
    },
    flattenItems(items) {
    return items.reduce((acc, item) => {
      if (item.Items && item.Items?.length) {
        item.Items.forEach((subItem) => {
          acc.push({ ...item, ...subItem });
        });
      } else {
        acc.push(item);
      }
      return acc;
    }, []);
  },
    maskCardNumber(cardNumber) {
      if (!cardNumber || cardNumber?.length < 15) return cardNumber; // Check if the card number is valid
      // return cardNumber.slice(0, 11) + '####'; // Show first 11 digits and mask the rest
      return '****' + cardNumber.slice(11, 15); // Show last 4 digits and mask the rest
    },
    openInvoiceDialog(type, item) {
      if (type === 'exam') {
        this.selectedExamPayment = item;
        this.examinvoicedialog = true;  
      }
      if (type === 'store') {
        this.selectedStorePayment = item;
        this.storeinvoicedialog = true; 
      }
      if (type === 'seminar') {
        this.selectedSeminarPayment = item;
        this.seminarinvoicedialog = true;  
      }
    },
    formatDate(date) {
      const options = {weekday: "long", year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    fetchUserPurchaseAndBillingsData(){
      this.tableLoader = true;
      const userId = this.GetPreviewUser.Id;
      this.$store.dispatch("GetUserPurchaseAndBillings", { id: userId }).then(() => {
        this.tableLoader = false;
        this.$store.dispatch("GetProductCategories");
      }).catch((error) => {
        console.error("Error fetching user orders:", error);
      });
    },
    seminarTableDiscountValue(item, seminarSubTotal) {
      // Calculate the discount for seminars based on DiscountType
      if (
        item &&
        item?.SeminarDetails[0]?.Coupon
      ) {
        const discount = item.SeminarDetails[0].Coupon.DiscountValue;
        const discountType = item.SeminarDetails[0].Coupon.DiscountType;
        // Convert percentage discount to dollar value if DiscountType is 1
        return discountType === 1
          ? ((discount / 100) * seminarSubTotal)?.toFixed(2)
          : discount?.toFixed(2);
      }
      return "0.00";
    },
    calculateTotalPaidAmount(item){
      const seminarsSubtotal = item?.SeminarDetails?.reduce((total, nestedItem) => {
        return total +  this.totalSeminarPrice(nestedItem)
      }, 0);
      let seminarDiscountValue = this.seminarTableDiscountValue(item,seminarsSubtotal)
      return seminarsSubtotal - seminarDiscountValue
    },
    close() {
      this.editdialog = false;
      this.editexam = false;
      this.addreseditdialog = false;
      this.add_dialog = false;
      this.snackbar = true;
      this.Memberinfoeditdialog = false;
      this.fetchUserPurchaseAndBillingsData()
    },
    closeDialog() {
      this.add_dialog = false;
      this.invoicedialog = false;
      this.value = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.editexam = false;
        this.addreseditdialog = false;
        this.addreseditdialog = false;
        this.Membereditdialog = false;
        this.billingeditdialog = false;
        this.Memberinfoeditdialog = false;
        this.editAddressdialog = false;
        this.btnloader = false;
      }, 2000);
    },
    orderDetails(OrderCode) {
      const userId = this.GetPreviewUser.Id;

      this.$router.push({
        path: "/users/userorder",
        query: { ordernumber: OrderCode, userId: userId },
      });
    },
  },
};
</script>
<style scoped>
.light-content {
  font-size: 20px;
  font-family: "DM Sans";
  font-weight: 400;
  color: #222222;
}
.style_txt_hh1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  color: rgba(34, 34, 34, 0.7);
}
table,
td,
th {
  border: 1px solid;
}
th {
  background-color: #cccccc;
}
</style>